import { useRecoilState } from 'recoil';

import { notificationState } from './notificationState';

/**
 * 알림 Dialog hook
 */
export function useNotificationDialog() {
  const [notification, setNotificationState] = useRecoilState(notificationState);

  const openNotification = () => {
    setNotificationState(prev => ({
      ...prev,
      isOpen: true,
    }));
  };

  const closeNotification = () => {
    setNotificationState(prev => ({
      ...prev,
      isOpen: false,
    }));
  };

  const toggleNotification = () => {
    setNotificationState(prev => ({
      ...prev,
      isOpen: !prev.isOpen,
    }));
  };

  return {
    isOpen: notification.isOpen,
    openNotification,
    closeNotification,
    toggleNotification,
  };
}
